import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import CurrentQuestion from './currentQuestion';
import StartScreen from './startScreen';
import ResultsComponent from './resultsComponent';
import { StepsContext } from '../context/StepsContext';
import { useContext } from 'react';
const componentLoader = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  return (
    <div className="app-body">
      <div className="summary">
        <Router>
          <Routes>
            <Route path="/bstad/" element={<StartScreen />} />
            <Route path={'/bstad/question/:currentID/:currentUrl'} element={<CurrentQuestion />} />
            <Route
              path={'/bstad/result/scored'}
              element={qContext.started ? <ResultsComponent /> : <Navigate to="/bstad/" />}
            />
            <Route
              path={'/bstad/result/riskLevel=:risk&drugs=:drugs'}
              element={<ResultsComponent />}
            />
          </Routes>
        </Router>
      </div>
    </div>
  );
};

export default componentLoader;
